import { axiosClient } from '../../clients/axios-client'
import type { ModelsResponseDto } from './dtos/chat'
import { ModelsResponseDtoSchema } from './dtos/chat'

export async function getModels() {
  try {
    const { data } = await axiosClient.get<ModelsResponseDto>('/chat/models', { timeout: 2000 })

    return ModelsResponseDtoSchema.parse(data)
  } catch (error) {
    console.error('Getting models failed', error)
    throw error
  }
}
